<!--
 * @Author: Wu Yinglei
 * @Date: 2021-08-12 13:41:31
 * @LastEditors: Wu Yinglei
 * @LastEditTime: 2021-08-23 14:12:22
 * @Description:
 * @FilePath: \lab820\src\App.vue
-->
<template>
  <div id="app"
       :class="{'mapp': showPage === 1}">
    <router-view/>
    <router-view v-if="showPage === 1"
                 name="m"></router-view>
    <router-view v-else
                 name="pc"></router-view>

  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      showPage: 1
    }
  },
  methods: {
    _isMobile() {
      return navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
    }
  },
  created() {
    if (this._isMobile()) {
      this.showPage = 1;
    } else {
      this.showPage = 2;
    }
  }
}
</script>

<style>
@import "./common/main.css";
</style>



// WEBPACK FOOTER //
// src/App.vue